import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnInit } from '@angular/core';
import { ExcelViewerService } from 'src/app/repository/service/excel-viewer.service';

@Component({
  selector: 'app-childkpi-reorder',
  templateUrl: './childkpi-reorder.component.html',
  styleUrls: ['./childkpi-reorder.component.scss']
})
export class ChildkpiReorderComponent implements OnInit {
  @Input() kpiGroup: any ={};
  public kpiListLocal:any[] = [];
  public kpiListOriginal:any[] = [];
  constructor(
    public evService:ExcelViewerService
  ) { }

  ngOnInit(): void {
    this.kpiListLocal = [];
    this.kpiListOriginal = [];
    let kpis = JSON.parse(JSON.stringify(this.kpiGroup));
    Object.keys(kpis).forEach((kpiKey) => {
      this.kpiListLocal.push({id :kpis[kpiKey].kpi_id, name: kpis[kpiKey].name, label: kpiKey, priority:kpis[kpiKey].kpi_id, isGroup: "rows" in kpis[kpiKey].options ? false : true, isOpenGroup:false, options:kpis[kpiKey].options});
      this.kpiListOriginal.push({id :kpis[kpiKey].kpi_id, name: kpis[kpiKey].name, label: kpiKey, priority:kpis[kpiKey].kpi_id})
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.kpiListLocal, event.previousIndex, event.currentIndex);
    setTimeout(() => {
      this.kpiTreeRerderMap()
    }, 100);
  }
  openGroup(kpi){
    kpi.isOpenGroup = !kpi.isOpenGroup
  }
  
  kpiTreeRerderMap(){
    this.kpiListOriginal.forEach((kpi) => {
      let index = <number> this.kpiListLocal.findIndex(rItem => rItem.id === kpi.id);
      kpi["priority"] = index + 1;
      this.evService.selectedSheetReorderedKpis[kpi["label"]] = kpi
    });
  }
}
